import { render, staticRenderFns } from "./LaidOutCheckBoxes.vue?vue&type=template&id=5f21cf4c&"
import script from "./LaidOutCheckBoxes.vue?vue&type=script&lang=js&"
export * from "./LaidOutCheckBoxes.vue?vue&type=script&lang=js&"
import style0 from "./LaidOutCheckBoxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {
  VChip,
})
